module.exports = __webpack_public_path__ + "img/brilliant-graphics.f1f032ab.jpg";